import { KANBAN_COLUMNS, type KanbanColumnId } from './osKanban';

export const KANBAN_RESTORE_KEY = 'nexus-kanban-restore';

export interface KanbanRestoreState {
  scrollByColumn: Partial<Record<KanbanColumnId, number>>;
  focusOsKey?: string;
}

export function saveKanbanRestoreState(state: KanbanRestoreState): void {
  sessionStorage.setItem(KANBAN_RESTORE_KEY, JSON.stringify(state));
}

export function readKanbanRestoreState(): KanbanRestoreState | null {
  const raw = sessionStorage.getItem(KANBAN_RESTORE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as KanbanRestoreState;
  } catch {
    return null;
  }
}

export function clearKanbanRestoreState(): void {
  sessionStorage.removeItem(KANBAN_RESTORE_KEY);
}

export function collectKanbanScrollPositions(
  boardElement: HTMLElement,
  focusOsKey?: string
): KanbanRestoreState {
  const scrollByColumn: Partial<Record<KanbanColumnId, number>> = {};

  KANBAN_COLUMNS.forEach((col) => {
    const columnElement = boardElement.querySelector(`[data-kanban-column="${col.id}"]`);
    if (columnElement instanceof HTMLElement) {
      scrollByColumn[col.id] = columnElement.scrollTop;
    }
  });

  return { scrollByColumn, focusOsKey };
}

export function restoreKanbanScrollPositions(boardElement: HTMLElement): boolean {
  const restore = readKanbanRestoreState();
  if (!restore) return false;

  KANBAN_COLUMNS.forEach((col) => {
    const scrollTop = restore.scrollByColumn[col.id];
    if (scrollTop == null) return;

    const columnElement = boardElement.querySelector(`[data-kanban-column="${col.id}"]`);
    if (columnElement instanceof HTMLElement) {
      columnElement.scrollTop = scrollTop;
    }
  });

  if (restore.focusOsKey) {
    const card = boardElement.querySelector(`[data-kanban-os-key="${restore.focusOsKey}"]`);
    card?.scrollIntoView({ block: 'nearest', behavior: 'auto' });
  }

  clearKanbanRestoreState();
  return true;
}
